module.exports = __webpack_public_path__ + "static/media/chart.f51f927d.svg";